import React from 'react';
import Hero from '../components/Hero';
import Process from '../components/Process';
import Clients from '../components/Clients';
import About from '../components/About';
import WhyUs from '../components/WhyUs';
import Partner from '../components/Partner';
import HireBanner from '../components/HireBanner';
import Contact from '../components/Contact';

const HomePage: React.FC = () => (
  <>
    <Hero />
    <div className="section-divider" />
    <Process />
    <div className="section-divider" />
    <Clients />
    <div className="section-divider" />
    <About />
    <div className="section-divider" />
    <WhyUs />
    <div className="section-divider" />
    <HireBanner />
    <div className="section-divider" />
    <Partner />
    <div className="section-divider" />
    <Contact />
  </>
);

export default HomePage;
